import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input
} from '@angular/core';

import { TableColumn  } from './types/table-column';
import { TableService } from './table.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector       : 'wor-table-cell',
  template: require('./table-cell.component.html')
})
export class TableCellComponent {
  @Input() column: TableColumn;
  @Input() row   : any;

  get data (): string {
    return this.tableService.formatCellData(this.row, this.column);
  }

  constructor (
    private changeDetector: ChangeDetectorRef,
    private tableService  : TableService
  ) {}

  markForCheck (): void {
    this.changeDetector.markForCheck();
  }
}